import { createContext, useContext } from "react";

import type { ReferenceCheckTemplateFormValues } from "../utils";

export const initialReferenceCheckTemplateValues: ReferenceCheckTemplateFormValues =
  {
    name: "",
    professional_quantity: 1,
    personal_quantity: 1,
    professional_questions: [""],
    personal_questions: [""],
  };

export interface ReferenceCheckTemplatesContextType {
  template: ReferenceCheckTemplateFormValues;
  setTemplate: (template: ReferenceCheckTemplateFormValues) => void;
  isLastStep: boolean;
  numberOfSteps: number;
  currentStep: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const ReferenceCheckTemplatesContext =
  createContext<ReferenceCheckTemplatesContextType>({
    template: initialReferenceCheckTemplateValues,
    setTemplate: () => {},
    isLastStep: false,
    numberOfSteps: 0,
    currentStep: 0,
    goToNextStep: () => {},
    goToPrevStep: () => {},
  });

export function useReferenceCheckTemplatesContext() {
  return useContext(ReferenceCheckTemplatesContext);
}
